import { render, staticRenderFns } from "./MonthlyAccountsReceivableSummary.vue?vue&type=template&id=08ef1679&scoped=true&"
import script from "./MonthlyAccountsReceivableSummary.vue?vue&type=script&lang=js&"
export * from "./MonthlyAccountsReceivableSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef1679",
  null
  
)

export default component.exports